import { render, staticRenderFns } from "./fcertificate.vue?vue&type=template&id=929b7788&scoped=true&"
import script from "./fcertificate.vue?vue&type=script&lang=js&"
export * from "./fcertificate.vue?vue&type=script&lang=js&"
import style0 from "./fcertificate.vue?vue&type=style&index=0&id=929b7788&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929b7788",
  null
  
)

export default component.exports